export const navigationIcon = {
  data: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="10" y="3" width="4" height="4" rx="1" fill="currentColor"/><rect x="10" y="10" width="4" height="4" rx="1" fill="currentColor"/><rect x="10" y="17" width="4" height="4" rx="1" fill="currentColor"/></svg>`,
  name: 'navigation' as const,
};
